<template>
  <div 
    class="desktop:hidden z-[200] fixed inset-0 bg-gradient-to-br from-royal-500 to-royal-950 flex flex-col items-center justify-start p-9 overflow-y-auto"
  >
    <!-- Logo -->
    <div class="w-20 h-8">
      <slot name="logo">
        <img 
          v-if="logoSrc" 
          :src="logoSrc" 
          alt="Logo" 
          class="h-full w-full object-contain"
        >
      </slot>
    </div>

    <div class="relative flex flex-col w-96 h-full items-center justify-start">      
      <!-- Ilustração de dispositivos -->
      <SmallDisplayIcon class="w-full h-3/4" />

      <div class="absolute flex flex-col items-center justify-start bottom-1/7">
        <!-- Título -->
        <h1 class="text-2xl text-white text-center">
          {{ title }}
        </h1>
        
        <!-- Mensagem explicativa -->
        <p class="text-white text-center text-xs mt-2">
          {{ message }}
        </p>
        
        <!-- Botão Sair -->
        <button 
          @click="handleExit"
          class="bg-white w-20 px-4 h-14 text-grey-950 text-xs rounded-lg font-medium flex items-center justify-center gap-2 mt-8 hover:bg-grey-50 transition-colors border border-grey-200"
        >
          <ExitIcon class="w-5 h-5" />
          {{ exitButtonText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { SmallDisplayIcon, ExitIcon } from '../../icons'

export interface SmallScreenBannerProps {
  /** Título exibido no banner */
  title?: string
  /** Mensagem explicativa */
  message?: string
  /** Texto do botão de sair */
  exitButtonText?: string
  /** URL da logo (opcional, pode usar slot) */
  logoSrc?: string
  /** URL de redirecionamento ao sair */
  exitUrl?: string
}

const props = withDefaults(defineProps<SmallScreenBannerProps>(), {
  title: 'Ops! Tela muito pequena',
  message: 'Detectamos que sua tela é menor que o recomendado. Para uma melhor experiência, acesse em um dispositivo com tela maior.',
  exitButtonText: 'Sair',
  exitUrl: window.location.href,
})

const emit = defineEmits<{
  exit: []
}>()

const handleExit = () => {
  emit('exit')
  // Tenta fechar a janela
  window.close()
  // Fallback: redireciona para URL externa
  window.location.href = props.exitUrl
}
</script>

